<template>
    <button
        type="button"
        class="btn btn-block text-nowrap btn-success"
        :class="{'btn-warning': value}"
        @click="toggle()"
    >{{value ? textOn : textOff}}</button>
</template>

<script>
export default {
    props: {
        textOn: { type: String },
        textOff: { type: String },
        value: { type: Boolean, default: true }, 
    },

    methods: {
        toggle() {
            this.$emit('toggle');
        }
    }
};
</script>